import React from 'react';
import { lobbyImage } from '../mock';

const CareBadge = ({ label }) => (
  <div className="w-28 h-28 rounded-2xl border border-white/25 bg-white/10 backdrop-blur flex flex-col items-center justify-center text-white text-center select-none">
    <div className="text-[11px] font-semibold tracking-[0.18em] uppercase">Care Focus</div>
    <div className="mt-2 text-[15px] font-bold leading-tight">{label}</div>
  </div>
);

const Award = () => {
  return (
    <section className="pt-4 pb-16 lg:pb-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="relative rounded-[28px] overflow-hidden min-h-[520px] lg:min-h-[560px]">
          <img src={lobbyImage} alt="Clinic interior" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/40" />
          <div className="relative z-10 px-8 lg:px-14 pt-14 lg:pt-16 max-w-3xl">
            <h3 className="text-white text-[24px] lg:text-[32px] leading-[1.15] font-semibold tracking-tight">
              A calm, well-equipped space for assessment, treatment, exercise, and patient education.
            </h3>
          </div>
          <div className="absolute z-10 left-8 lg:left-14 bottom-14 flex gap-4">
            <CareBadge label="Hands-on Care" />
            <CareBadge label="Active Rehab" />
          </div>
          <p className="absolute z-10 right-8 lg:right-14 bottom-6 text-white/80 text-[12px] max-w-xs text-right">
            Treatment plans are tailored after assessment and guided by patient goals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Award;
